<template>
     <div>
        <div class="row">
            <div class="col-md-12 header-row">
                <h3 class="heading semi-bold">
                    {{pageTitle}}
                    <button class="btn btn-primary pull-right" @click="setToToday()">
                        View Today's Changes
                    </button>
                </h3>
                <div class="row">
                    <div class="col-md-3">
                        <label>Date From</label>
                        <datepicker :clear-button="true" placeholder="Date From" v-model="dateFrom" input-class="form-control">
                        </datepicker>
                    </div>
                    <div class="col-md-3">
                        <label>Date To</label>
                        <datepicker :clear-button="true" placeholder="Date To" v-model="dateTo" input-class="form-control">
                        </datepicker>
                    </div>
                    <div class="col-md-2">
                        <label>Timezone</label>
                        <v-select :options="timezones" v-model="selectedTimezone"></v-select>
                    </div>
                    <div class="col-md-4 text-right">
                        <pagination
                             :total-pages="serverParams.totalPages"
                             :total="totalRows"
                             :per-page="serverParams.perPage"
                             :current-page="serverParams.page"
                             @pagechanged="onPageChange"
                         />
                    </div>
                </div>
            </div>
        </div>

        <!-- table -->
        <div class="row">
             <div class="col-md-12">
                 <div class="grid bg-white added-margin shadow">
                     <div class="grid-title">
                         <h4>
                             Total - {{ totalRows }} Row<span v-if="rows.length > 1">s</span>
                             <span class="pull-right" v-if="isLoading"><i class="fa fa-spinner fa-spin" aria-hidden="true"></i> Loading ...</span>
                         </h4>
                     </div>
                     <div class="grid-body">
                         <div class="responsive-table-container">
                             <table class="table-responsive" border='1'>
                                 <thead>
                                    <tr>
                                        <th>Fabric ID</th>
                                        <th>Old Status</th>
                                        <th>New Status</th>
                                        <th>Old Note</th>
                                        <th>New Note</th>
                                        <th>Free Stock</th>
                                        <th>Reserved Stock</th>
                                        <th>Future</th>
                                        <th>Average Usage</th>
                                        <th>Type</th>
                                        <th>Reason</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody v-if="!isLoading">
                                    <template v-for="row in rows">
                                        <tr v-if="!isLoading">
                                            <template v-for="(value,index) in row" v-if="columns.indexOf(index) !== -1">
                                                <td class="col-sm-3" v-if="index == 'old_status' || index == 'new_status'">
                                                    <span :class="'badge badge-'+getStatusColor(value)">
                                                        {{ value.replace(/_/g, ' ') }}
                                                    </span>
                                                </td>
                                                <td class="col-sm-5" v-else-if="index == 'reason'">
                                                    <p class="reason-text">{{value}}</p>
                                                </td>
                                                <td class="text-center" v-else>
                                                    {{value}}
                                                </td>
                                            </template>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                             <p class="text-center" v-if="rows.length == 0 && !isLoading">No results were found.</p>
                         </div>

                         <pagination
                             :total-pages="serverParams.totalPages"
                             :total="totalRows"
                             :per-page="serverParams.perPage"
                             :current-page="serverParams.page"
                             @pagechanged="onPageChange"
                         />
                     </div>
                 </div>
             </div>
        </div>
     </div>
</template>
<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import { VueGoodTable } from "vue-good-table";
import pagination from "@/pages/Tools/pagination";
import _ from "lodash";

export default {
  mounted() {
    this.dateFrom = new Date(new moment().startOf("today"));
    this.dateTo = new Date(new moment().endOf("today"));
    this.dateToday = new Date(new moment().startOf("today"));
    this.selectedTimezone = this.timezones.filter((tz) => tz.value == "UTC")[0];
  },
  components: {
    VueGoodTable,
    Datepicker,
    pagination,
  },
  data: () => ({
    columns: [
      "fabric_id",
      "old_status",
      "new_status",
      "old_note",
      "new_note",
      "free_stock_text",
      "reserved_stock_text",
      "future",
      "average_usage_text",
      "type",
      "reason",
      "created_at_text",
    ],
    timezones: [
      { value: "UTC", label: "Server Time" },
      { value: "Europe/Berlin", label: "Germany" },
      { value: "Asia/Bangkok", label: "Thailand" },
    ],
    pageTitle: "Fabrics that have changed status today",
    isLoading: false,
    dateFrom: null,
    dateTo: null,
    dateToday: null,
    selectedTimezone: null,
    rows: [],
    totalRows: 0,
    serverParams: {
      totalPages: 1,
      page: 1,
      perPage: 20,
    },
  }),
  methods: {
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    getStatusColor(status) {
      if (["available"].includes(status)) {
        return "primary";
      } else if (
        ["soon_sold_out_not_coming_back", "soon_sold_out_coming_back"].includes(
          status
        )
      ) {
        return "warning";
      } else {
        return "danger";
      }
    },
    async getFabricStatusLogs() {
      this.isLoading = true;
      this.rows = [];

      let params =
        "from=" +
        moment(this.dateFrom).format("YYYY-MM-DD") +
        "&to=" +
        moment(this.dateTo).format("YYYY-MM-DD") +
        "&page=" +
        this.serverParams.page +
        "&rows_per_page=" +
        this.serverParams.perPage +
        "&timezone=" +
        this.selectedTimezone.value;

      try {
        let res = await axios.get("/v2/fabrics/status_logs?" + params);
        this.rows = res.data.data;
        this.totalRows = res.data.meta.total;
        this.updateParams({
          page: res.data.meta.current_page,
          totalPages: res.data.meta.last_page,
        });
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }

      this.isLoading = false;
    },
    async onPageChange(page) {
      this.updateParams({ page: page });
      await _.debounce(this.getFabricStatusLogs(), 300);
    },
    updatePageTitle() {
      if (this.dateFrom == null && this.dateTo == null) {
        this.pageTitle = "Choose a date range to view Fabric Status changes";
        return;
      }

      if (
        moment(this.dateFrom).isSame(moment(this.dateTo), "day") &&
        moment(this.dateFrom).isSame(moment(this.dateToday), "day")
      ) {
        this.pageTitle = "Fabrics that have changed status today";
        return;
      }

      var title =
        "Fabrics that have changed status between {startDate} and {endDate}";
      title =
        this.dateFrom == null
          ? title.replace("{startDate}", '""')
          : title.replace(
              "{startDate}",
              moment(this.dateFrom).format("DD-MMM-YYYY")
            );
      title =
        this.dateTo == null
          ? title.replace("{endDate}", '""')
          : title.replace(
              "{endDate}",
              moment(this.dateTo).format("DD-MMM-YYYY")
            );
      this.pageTitle = title;
    },
    setToToday() {
      this.dateFrom = new Date(new moment().startOf("today"));
      this.dateTo = new Date(new moment().endOf("today"));
    },
  },
  watch: {
    async dateFrom() {
      if (this.dateFrom !== null) {
        this.updateParams({ page: 1 });
        await _.debounce(this.getFabricStatusLogs(), 300);
      }
      this.updatePageTitle();
    },
    async dateTo() {
      if (this.dateFrom !== null) {
        this.updateParams({ page: 1 });
        await _.debounce(this.getFabricStatusLogs(), 300);
      }
      this.updatePageTitle();
    },
    async selectedTimezone() {
      if (this.selectedTimezone !== null) {
        this.updateParams({ page: 1 });
        await _.debounce(this.getFabricStatusLogs(), 300);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~sweetalert2/dist/sweetalert2.min.css";
@import "~vue-good-table/dist/vue-good-table.css";

div.grid-title h4 {
  width: 100%;
}

.responsive-table-container {
  display: block;
  overflow-x: auto;
  white-space: nowrap;
}

.table-responsive {
  max-width: none;
  width: 100%;
}

.table-responsive th,
td {
  width: 100%;
  padding: 13px !important;
}

th {
  position: sticky;
  top: -1px;
  z-index: 1;
  background: var(--primary-color);
  color: white;
}

.header-row {
  margin-bottom: 20px;
}

.header-row .search-fabric {
  height: 38px;
}

.form-control {
  height: 38px;
}
.input-group-addon {
  height: 38px !important;
}
.img {
  height: 40px;
  width: 40px;
  border-radius: 5px;
}
.tiles-title {
  font-size: 14px;
  color: #4f5458;
  font-weight: bold;
}
hr {
  border-bottom: 0.02px solid #e6e6e6 !important;
  margin: 10px 0px 0px 0px !important;
}
.dropdown-menu {
  right: 0;
  left: auto;
  padding-left: 1px;
  padding-right: 1px;
  border: 1px solid #27a699;
}
.up-par {
  background: #f1f1f1;
}
.time-frame {
  margin-top: -33px !important;
  margin-bottom: 0px !important;
  float: right;
}

.table tr th {
  position: sticky !important;
  top: -1px;
  text-align: center;
}

.reason-text {
  width: 300px;
  white-space: normal !important;
}
</style>
